<template>
  <transition @before-enter="beforeEnter" @enter="enter" @leave="leave" :css="false" appear>
    <section :class="this.name">
      <div class="bg"></div>
      <div class="content">
        <detail v-show="activeLayer == 'world1'">
          <h1 class="detail__title"><img :src="`${$staticUrl}img/detail/world/title.png`" alt=""></h1>
          <p class="detail__sub-title"><img :src="`${$staticUrl}img/detail/world/sub-title.png`" alt=""></p>

          <slide ref="world1"
                 @transitionend="handleTransitionEnd"
                 @transitionstart="handleTransitionStart"
                 :slideList="layerData.world1.list"
                 :width="documentSize.width"
                 :height="layerData.world1.height"
                 :noPagination="true">

            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/world/con-4.png`" alt="" slot="slide0"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/world/con-1.png`" alt="" slot="slide1"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/world/con-2.png`" alt="" slot="slide2"/>`,
            <img class="promokit-slide__img" :src="`${this.$staticUrl}img/detail/world/con-3.png`" alt="" slot="slide3"/>`,
          </slide>

          <div class="slide-dot-area">
            <button v-for="(item, index) in layerData.world1.list"
                    :class="['slide-dot-area__button', layerData.world1.index == index && 'slide-dot-area__button--active']"
                    @click="handleClickTo(index)">{{index}}
            </button>
          </div>
        </detail>

        <detail v-show="activeLayer == 'world2'">
          <div id="world-video-1" class="youtube-player" style="width:1400px;height:780px;position:relative;top:50%;left:50%;margin-left:-700px;"></div>
        </detail>
      </div>
    </section>
  </transition>
</template>
<script>
  import BasePage from "./mixins/basePage.js";
  import YoutubePlayer from "promokit-youtubeplayer";

  export default {
    name: "world",
    mixins: [BasePage],
    data() {
      return {
        name: "world",
        contentData: [
          //{type: "bg", source: this.$staticUrl + "img/bg_6.jpg", objName: "bg"},
          {type:'bg', source:'https://vod.plaync.com/lineage/remaster0320/0320_remaster_bg6.mp4', objName:'bgmovie'},
          {type: "chr", source: this.$staticUrl + "img/obj_6.png", objName: "chr_1", x: -94, y: 184},
          {type: "txt", source: this.$staticUrl + "img/txt_6_tit.png", objName: "obj_tit", x: 958, y: 382},
          {type: "txt", source: this.$staticUrl + "img/txt_6_stit.png", objName: "obj_stit", x: 937, y: 416},
          {type: "txt", source: this.$staticUrl + "img/txt_6_txt.png", objName: "obj_txt", x: 967, y: 613},
          {type: "btn", source: this.$staticUrl + "img/btn_6_1.png", objName: "world1", x: 962, y: 705},
          {type: "btn", source: this.$staticUrl + "img/btn_6_2.png", objName: "world2", x: 1133, y: 705},
        ],
        layerData: {
          world1: {
            list: 4,
            index: 0,
            height: 578,
            top: 262,
          },
        },
      };
    },
    methods: {
      canvasSet() {
        this.baseCavasSet(this.contentData);
      },
      enter(el, done) {
        this.baseEnter();
        this.canvasSet();
        //this.canvas.start();
        this.baseEnterMotion(el, done, this.contentData);
        this.enterMotion.play();
      },
      leave(el, done) {
        if (this.enterMotion) this.enterMotion.pause();
        this.baseLeaveMotion(el, done);
      },
    },
    mounted() {
      let videoWorld = new YoutubePlayer({
        el: "#world-video-1",
        videoId: "ItmUahQ837o",
      });

      videoWorld.on("play", () => {
        window.nowPlayingVideo = videoWorld;
      });
    },
  };
</script>